import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import { connect } from 'react-redux';
import { api } from "../../../../../../api/index";
import FileDropZoneDialog from '../../parts/FileDropZoneDialog';
import PromotionVariantActionsTop from './includes/actionsTop';
import PromotionVariantActionsBottom from './includes/actionsBottom';

class PromotionVariantActieblockComponent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			dropZoneModal: {
				open: false
			}
		};

		this.handlePositionFieldState = this.handlePositionFieldState.bind(this);
		this.selectImage = this.selectImage.bind(this);
	}

	handlePositionFieldState(event) {

		const target = event.target;
		const name = target.name;
		const value = target.value;

		api.promotions.handlePositionFieldState( name, value, this.props.periodKey, this.props.variantKey );
	}

	selectImage(image) {
		this.setState({
			...this.state,
			image: image
		});

		api.promotions.handlePositionFieldState( 'image', image, this.props.periodKey, this.props.variantKey );
	}

    render() {

		const variant = this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey];

		return (
			<div className={undefined === variant.active || true === variant.active ? 'medium-12 cell promotion__variation' : 'medium-12 cell promotion__variation promotion__variation--inactive' }>
				<PromotionVariantActionsTop
					handleActive={this.props.handleActive}
					removeVariation={this.props.removeVariation}
					periodKey={this.props.periodKey}
					variantKey={this.props.variantKey}
				/>

				<div className="grid-x grid-margin-y grid-padding-x grid-margin-x">
					<div className="medium-12 cell">
						<label>
							Titel
							<TextField
								onChange={this.handlePositionFieldState}
								value={this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].title}
								id={'actieblock-' + this.props.periodKey + '-variant-' + this.props.variantKey + '-title' }
								fullWidth={true}
								name="title"
							/>
						</label>
					</div>
					<div className="medium-12 cell">
						<label>
							Promotietekst
							<TextField
								onChange={this.handlePositionFieldState}
								value={this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].text}
								id={'actieblock-' + this.props.periodKey + '-variant-' + this.props.variantKey + '-text' }
								fullWidth={true}
								multiLine={true}
								name="text"
							/>
						</label>
					</div>
					<div className="medium-6 cell">
						<label>
							Afbeelding
							<FileDropZoneDialog
								onDrop={this.processFiles}
								promotionType="actieBlock"
								selectImage={this.selectImage}
								dimensions={[{width: 214, height: 156}]}
							/>
							{undefined !== this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].image && this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].image.thumbPath &&
							<img src={this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].image.thumbPath} />
							}
						</label>
						<small>De afbeelding dient een exact formaat van 214x156 pixels te hebben.</small>
					</div>
					<div className="medium-6 cell">
						<label>
							CTA Tekst
							<TextField
								onChange={this.handlePositionFieldState}
								value={this.props.promotion.periods[this.props.periodKey].variants[this.props.variantKey].ctatext}
								id={'actieblock-' + this.props.periodKey + '-variant-' + this.props.variantKey + '-cta-text' }
								fullWidth={true}
								name="ctatext"
							/>
						</label>
					</div>
				</div>
				<PromotionVariantActionsBottom
					periodKey={this.props.periodKey}
					variantKey={this.props.variantKey}
				/>
			</div>
		);
	}
}

const mapStateToProps = ( state ) => {
	return {
		promotion: state.promotion
	}
}

export default connect(mapStateToProps)(PromotionVariantActieblockComponent)


// WEBPACK FOOTER //
// ./src/application/components/promotions/components/types/variants/actieblock.js